export default __webpack_public_path__ + "static/media/ys1.fd4bfc45.PNG";